import IAIClientClass from './iai_client';

const IAIClient = new IAIClientClass();

export {
    IAIClient,
};
